<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Pegawai
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-add">Tambah Pegawai</a>
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>
        Daftar Pegawai
        <span>
          <DxButton
            icon="plus"
            text="Tambah"
            @click="addPegawaiBaru"
            styling-mode="outlined"
            type="default"
          />
        </span>
      </h5>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          class="dx-card wide-card"
          ref="gridRef"
          id="dataGrid"
          :data-source="dataSource"
          :focused-row-index="0"
          :show-borders="true"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :allow-column-reordering="true"
          @exporting="onExporting"
          @option-changed="onPageChanged"
          :filter-value="filterValue"
          :filter-sync-enabled="true"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{ mode: 'virtual' }"
        >
          <DxScrolling mode="virtual" row-rendering-mode="virtual" />

          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />

          <dx-filter-row :visible="true" />
          <DxFilterRow :visible="true" :apply-filter="currentFilter" />
          <DxHeaderFilter :visible="true" />

          <DxExport :enabled="true" :allow-export-selected-data="false" />
          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />
          <DxToolbar>
            <DxItem name="groupPanel" />
            <DxItem location="after" template="refresh-template" />
            <!-- <DxItem location="after" template="button-template" /> -->
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <!-- <template #button-template>
            <DxButton text="Import data" :width="136" @click="importClick" />
          </template> -->

          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('gridRef')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>

          <!-- <DxColumn
            caption="#"
            data-field="pegawai_id"
            data-type="number"
            :cell-template="cellRenderer"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
          />
          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template> -->
          <!-- <dx-column
            data-field="id"
            caption="PEGAWAIID"
            :allow-sorting="true"
            :fixed="true"
            fixed-position="left"
          /> -->

          <dx-column
            data-field="nik"
            caption="NIK"
            :allow-sorting="true"
            :fixed="true"
            fixed-position="left"
            data-type="string"
          />
          <!-- <dx-column
            data-field="id"
            caption="Pegawai Id"
            :allow-sorting="true"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          /> -->
          <dx-column
            data-field="nama"
            caption="Nama Pegawai"
            :allow-sorting="true"
            :fixed="true"
            fixed-position="left"
            data-type="string"
          />

          <DxColumn data-field="jenis_kelamin" caption="L/P" data-type="string">
          </DxColumn>

          <DxColumn
            data-field="umur"
            caption="Umur"
            :calculate-cell-value="calculateCellUmur"
            :calculate-filter-expression="calculateFilterExpressionUmur"
            :filter-operations="filterOperations"
            data-type="number"
          >
          </DxColumn>

          <DxColumn
            data-field="status_aktif_id"
            caption="Status Aktif"
            data-type="number"
          >
            <DxLookup
              :data-source="statusAktifSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <DxColumn
            data-field="tgl_lahir"
            caption="Tgl Lahir"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />

          <DxColumn
            data-field="tgl_mulai_bekerja"
            caption="Tgl Mulai Bekerja"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />

          <DxColumn
            data-field="pensiun_tgl"
            caption="Tgl Pensiun"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />

          <!-- <DxColumn data-field="riwayatGolongans[0].golongan_id" caption="Gol.">
            <DxLookup
              :data-source="golonganSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn> -->
          <DxColumn
            data-field="simpegNaikPangkats[0].golongan_id"
            caption="Gol."
            data-type="number"
          >
            <DxLookup
              :data-source="golonganSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <DxColumn
            data-field="simpegKgbs[0].masa_kerja"
            caption="Masa Kerja Tahun (KGB)"
            cell-template="template-mk-tahun"
            data-type="number"
            :calculate-filter-expression="calculateFilterExpression"
            :filter-operations="filterOperations"
          >
          </DxColumn>
          <DxColumn
            data-field="simpegKgbs[0].masa_kerja_bulan"
            caption="Masa Kerja Bulan (KGB)"
            cell-template="template-mk-bulan"
            data-type="number"
          >
          </DxColumn>

          <template #template-mk-bulan="{ data }">
            {{ data.text }} Bulan
          </template>
          <template #template-mk-tahun="{ data }">
            {{ data.text }} Tahun
          </template>

          <DxColumn
            data-field="riwayatPekerjaans[0].pegawai_status_id"
            caption="Status Pegawai"
            data-type="number"
          >
            <DxLookup
              :data-source="pegawaiStatusSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaans[0].cabang_id"
            data-type="number"
            caption="Cabang"
          >
            <DxLookup
              :data-source="cabangSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaans[0].unit_id"
            caption="Unit"
            data-type="number"
          >
            <DxLookup
              :data-source="unitSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <DxColumn
            data-field="riwayatPekerjaans[0].jabatan_id"
            data-type="number"
            caption="Jabatan"
          >
            <DxLookup
              :data-source="jabatanSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <DxColumn
            data-field="riwayatPekerjaans[0].bagian_id"
            data-type="number"
            caption="Bagian"
          >
            <DxLookup
              :data-source="bagianSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaans[0].sub_bagian_id"
            data-type="number"
            caption="Sub Bagian"
          >
            <DxLookup
              :data-source="subBagianSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaans[0].bidang_id"
            data-type="number"
            caption="Bidang"
          >
            <DxLookup
              :data-source="bidangSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <DxColumn
            data-field="riwayatPekerjaans[0].sub_bidang_id"
            data-type="number"
            caption="Sub Bidang"
          >
            <DxLookup
              :data-source="subBidangSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>
          <DxColumn
            data-field="riwayatPekerjaans[0].seksi_id"
            caption="Seksi"
            data-type="number"
          >
            <DxLookup
              :data-source="seksiSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn>

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="id"
            caption=" "
            :allow-exporting="false"
            :allow-filtering="false"
            data-type="number"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>

          <!-- <template #cabang-cell-template="{ data }">
            {{ getCabang(data.value) }}
          </template> -->
          <!-- <DxSummary>
            <DxTotalItem column="nik" summary-type="count" />
          </DxSummary> -->
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
/* eslint-disable */
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import { ODATA_BASE_URL } from "@/global-constants";
import _ from "lodash";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  // DxEditing,
  DxColumnFixing,
  // DxSelection,
  DxExport,
  // DxButton,
  DxToolbar,
  DxItem,
  DxLookup,
  DxHeaderFilter,
  DxScrolling,
  // DxSummary,
  // DxTotalItem,
} from "devextreme-vue/data-grid";
import DxButton from "devextreme-vue/button";
import notify from "devextreme/ui/notify";
import DxDropDownButton from "devextreme-vue/drop-down-button";
// eslint-disable-next-line
import router from "@/router";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { confirm } from "devextreme/ui/dialog";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import axios from "axios";
import { DateTime } from "luxon";

import { useGolonganStore } from "@/stores/GolonganStore";
import { useJabatanStore } from "@/stores/JabatanStore";
import { useBagianStore } from "@/stores/BagianStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";
import { usePegawaiStatusStore } from "@/stores/PegawaiStatusStore";
import { useStatusAktifStore } from "@/stores/StatusAktifStore";

// const cabangDataSource = new DataSource({
//   store: cabangStore,
// });

const options = ["Detail Pegawai", "Absensi", "Riwayat Gaji"];

const ds = new DataSource({
  store: new ODataStore({
    // ODataStore is configured here
    url: `${ODATA_BASE_URL}/SimpegPegawais`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      console.log("ds", e.params);
      if (hasFilterNestedTable(e.params.$filter)) {
        console.log("debug", "masuk hasilfilternestedtable");
        // e.params.$filter = convertFilter(e.params.$filter, "riwayatGolongans");
        e.params.$filter = convertFilter(
          e.params.$filter,
          "simpegNaikPangkats"
        );

        e.params.$filter = convertFilter(e.params.$filter, "simpegKgbs");

        e.params.$filter = convertFilter(e.params.$filter, "riwayatPekerjaans");
      }
      console.log("beforeSend DS", e);

      e.params.$orderby = "id";
    },
  }),
  expand: [
    "riwayatPekerjaans($filter=status eq 1)",
    // "riwayatGolongans($filter=status eq 1)",
    // "simpegNaikPangkats($filter=status eq 1)",
    "simpegNaikPangkats($orderby=tgl desc;$filter=status eq 1)",
    // "simpegKgbs($orderby=tgl desc;$filter=prediksi eq 0)",
    "simpegKgbs($orderby=tgl desc;$filter=status eq 1)",
  ],
});

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,

    DxPager,
    DxPaging,
    // DxEditing,
    DxColumnFixing,
    DxButton,
    DxDropDownButton,
    DxExport,
    // DxSelection,
    DxToolbar,
    DxLookup,
    DxItem,
    DxHeaderFilter,
    DxScrolling,
    // DxSummary,
    // DxTotalItem,
  },
  setup() {
    const golonganStore = useGolonganStore();
    const jabatanStore = useJabatanStore();
    const bagianStore = useBagianStore();
    const bidangStore = useBidangStore();
    const subBagianStore = useSubBagianStore();
    const subBidangStore = useSubBidangStore();
    const seksiStore = useSeksiStore();
    const cabangStore = useCabangStore();
    const unitStore = useUnitStore();
    const pegawaiStatusStore = usePegawaiStatusStore();
    const statusAktifStore = useStatusAktifStore();
    return {
      golonganStore,
      jabatanStore,
      bagianStore,
      bidangStore,
      subBagianStore,
      subBidangStore,
      seksiStore,
      cabangStore,
      unitStore,
      pegawaiStatusStore,
      statusAktifStore,
    };
    // const picture = "images/employees/06.png";
    // const imageUrl = `https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/${picture}`;
  },
  data() {
    const vm = this;
    return {
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      filterOperations: ["=", "<>", ">", "<", "between"],

      calculateFilterExpressionUmur: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        console.log("CALCULATEFILTEREXP filterValue", filterValue);
        console.log(
          "CALCULATEFILTEREXP selectedFilterOperation",
          selectedFilterOperation
        );
        console.log("CALCULATEFILTEREXP target", target);
        console.log("FIELD caption", this);
        var colFilter = "tgl_lahir";
        if (this.caption === "Masa Kerja Tahun (KGB)") {
          colFilter = "simpegKgbs[0]/masa_kerja";
        }
        if (selectedFilterOperation === "=" && target == "filterBuilder") {
          let filterExpression = [];
          console.log("cal 1");
          if (filterValue == 0) {
            filterExpression.push([colFilter, "=", null]);

            console.log("masuk filterexpression 0");
          } else {
            filterExpression.push(
              [colFilter, "<=", vm.calculateDateFromAge(filterValue)],
              [
                colFilter,
                ">",
                vm.calculateDateFromAge(parseInt(filterValue) + 1),
              ]
            );
          }

          console.log("FINAL FILTEREXPRESSION", filterExpression);
          return filterExpression;
        }

        if (selectedFilterOperation === ">" && target == "filterBuilder") {
          console.log("cal 2");
          console.log(">", filterValue);
          let filterExpression = [
            [
              colFilter,
              "<",
              vm.calculateDateFromAge(parseInt(filterValue) + 1),
            ],
          ];
          console.log(">", filterExpression);
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterBuilder") {
          console.log("cal 5");
          console.log("<>", filterValue);
          let filterExpression = [
            [colFilter, "<>", vm.calculateDateFromAge(parseInt(filterValue))],
          ];
          console.log(">", filterExpression);
          return filterExpression;
        }

        if (selectedFilterOperation === "<" && target == "filterBuilder") {
          console.log("cal 3");
          console.log("<", filterValue);
          let filterExpression = [
            [colFilter, ">", vm.calculateDateFromAge(filterValue)],
          ];
          console.log("<", filterExpression);
          return filterExpression;
        }

        if (
          selectedFilterOperation === "between" &&
          target == "filterBuilder"
        ) {
          console.log("cal 4");
          console.log(
            "BETWEEN selectedFilterOperation",
            selectedFilterOperation
          );
          console.log("BETWEEN target", target);
          if (typeof filterValue === "string") {
            let coba = filterValue
              .split(",")
              .map((part) => Number(part.trim()));
            console.log("coba", coba);
            filterValue = coba;
          }
          console.log("FINAL BETWEEN filterValue", filterValue);
          const minAge = filterValue[0];
          const maxAge = filterValue[1];
          if (minAge !== undefined && maxAge !== undefined) {
            return [
              [colFilter, ">", vm.calculateDateFromAge(parseInt(maxAge) + 1)], // Using '<' to include the exact date of birth
              [colFilter, "<", vm.calculateDateFromAge(minAge)],
            ];
          } else if (minAge !== undefined) {
            return [[colFilter, "<", vm.calculateDateFromAge(minAge)]];
          } else if (maxAge !== undefined) {
            return [
              [colFilter, ">", vm.calculateDateFromAge(parseInt(maxAge) + 1)],
            ];
          } else {
            return null; // Return null to indicate that no filter should be applied
          }
        }
      },

      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        var colFilter = "simpegKgbs[0]/masa_kerja";

        if (selectedFilterOperation === "=" && target == "filterBuilder") {
          let filterExpression = [];
          console.log("cal 1");
          filterExpression.push([colFilter, "=", filterValue]);

          return filterExpression;
        }

        if (selectedFilterOperation === ">" && target == "filterBuilder") {
          let filterExpression = [[colFilter, ">", filterValue]];

          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterBuilder") {
          let filterExpression = [[colFilter, "<>", filterValue]];

          return filterExpression;
        }

        if (selectedFilterOperation === "<" && target == "filterBuilder") {
          let filterExpression = [[colFilter, "<", filterValue]];

          return filterExpression;
        }

        if (
          selectedFilterOperation === "between" &&
          target == "filterBuilder"
        ) {
          console.log("debug cal 4");
          console.log(
            "debug BETWEEN selectedFilterOperation",
            selectedFilterOperation
          );
          console.log("debug BETWEEN target", target);
          if (typeof filterValue === "string") {
            let coba = filterValue
              .split(",")
              .map((part) => Number(part.trim()));
            console.log("debug coba", coba);
            filterValue = coba;
          }
          console.log("debug FINAL BETWEEN filterValue", filterValue);
          const minAge = filterValue[0];
          const maxAge = filterValue[1];
          if (minAge !== null && maxAge !== null) {
            return [
              [colFilter, ">=", minAge], // Using '<' to include the exact date of birth
              [colFilter, "<=", maxAge],
            ];
          } else if (minAge !== null) {
            return [[colFilter, ">=", minAge]];
          } else if (maxAge !== null) {
            console.log("debug maxage is no undefined", [
              colFilter,
              "<=",
              maxAge,
            ]);
            return [[colFilter, "<=", maxAge]];
          } else {
            return null; // Return null to indicate that no filter should be applied
          }
        }
      },

      // filterValue: ["riwayatPekerjaans[0].pegawai_status_id", "=", 1],
      filterValue: [["status_aktif_id", "=", 1]],
      pensiunSource: [
        { val: true, nama: "Pensiun" },
        { val: false, nama: "Aktif" },
      ],

      numberingPageSize: 100,
      numberingPageNumber: 0,

      ds,
      events: [],
      jenisKelaminSource: ["L", "P"],
      dataSource: ds,

      statusAktifSource: new ODataStore({
        url: `${ODATA_BASE_URL}/StatusAktifs`,
        key: "id",
      }),

      pegawaiStatusSource: null,

      jabatanSource: null,

      cabangSource: null,

      unitSource: null,

      bagianSource: null,

      bidangSource: null,

      subBagianSource: null,

      subBidangSource: null,

      seksiSource: null,
      golonganSource: null,
      options: options,
      router: router,
    };
  },
  async mounted() {
    console.log("check sftp");
    this.golonganSource = await this.golonganStore.get();
    this.jabatanSource = await this.jabatanStore.get();
    this.bagianSource = await this.bagianStore.get();
    this.bidangSource = await this.bidangStore.get();
    this.subBagianSource = await this.subBagianStore.get();
    this.subBidangSource = await this.subBidangStore.get();
    this.seksiSource = await this.seksiStore.get();
    this.cabangSource = await this.cabangStore.get();
    this.unitSource = await this.unitStore.get();
    this.pegawaiStatusSource = await this.pegawaiStatusStore.get();
    this.statusAktifSource = await this.statusAktifStore.get();

    console.log("golonganStore", this.golonganStore.get());
    // Access the 'filter' query parameter
    // if (this.$route.query.filter) {
    //   alert("ada");
    //   this.filterValue = this.$route.query.filter;
    //   this.filterValue[2] = parseInt(this.filterValue[2]);
    //   console.log("Filter value:", this.filterValue);
    // } else {
    //   alert("tidak ada");
    // }
    this.getUrlFilter();
    console.log("Filter value:", this.filterValue);
  },
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    // cellRenderer(cellElement, cellInfo) {
    //   cellElement.innerText =
    //     this.numberingPageNumber * this.numberingPageSize +
    //     cellInfo.row.rowIndex +
    //     1;
    // },
    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    calculateDateFromAge(age) {
      const today = DateTime.local();
      return today.minus({ years: age }).toJSDate();
    },

    calculateCellUmur(e) {
      // this.calculateDateFromAge(1);
      // return 20;
      return this.hitungUmur(e.tgl_lahir);
    },

    hitungUmur(tgl) {
      const birthDateObj = DateTime.fromISO(tgl);
      const today = DateTime.local();
      const age = today.diff(birthDateObj, "years").years;
      // console.log("hitungUmur", tgl);
      if (tgl === null) return 0;
      return Math.floor(age);
    },
    getUrlFilter() {
      if (this.$route.query.filter) {
        let filter = this.$route.query.filter;
        if (!isNaN(filter[2]) && typeof +filter[2] === "number") {
          // alert("The third element is a number");
          filter[2] = parseInt(this.$route.query.filter[2]);
        } else {
          // alert("The third element is not a valid number");
        }

        console.log("Filter value from getUrlFilter:", filter);
        this.filterValue.push(filter);
        console.log(
          "Filter value from getUrlFilter after push:",
          this.filterValue
        );
        return filter;
      } else {
        return null;
      }
    },
    getFilterValue() {
      const filterValue = this.$route.query.filter;
      console.log("Filter value:", filterValue);
    },

    onPageChanged(e) {
      // console.log("onpagechanged");
      // console.log(e);
      if (e.fullName == "paging.pageIndex") {
        console.log("===========UBAH PAGING============");
        let currentPage = e.value;
        console.log("halaman " + e.value);
        console.log("jumlahrow " + this.$refs.gridRef.instance.pageSize());
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    addPegawaiBaru() {
      this.router.push({
        name: "simpeg-pegawai-add",
      });
    },
    getCabang(index) {
      // console.log(index);
      // console.log(cabangStore)
      //  const coba = _.find(this.cabangs, { id: index });
      // return coba.nama;
    },
    dataEx() {
      console.log(this.pegawaiDataSource);
    },
    importClick() {
      this.router.push({
        name: "simpeg-pegawai-import2",
      });
    },
    logEvent(eventName) {
      this.events.unshift(eventName);
    },
    clearEvents() {
      this.events = [];
    },

    onSaving(e) {
      console.log(e);
    },
    myCommand(e) {
      console.log(e);
      alert("command");
    },
    onItemClick(e) {
      console.log("ONITEMCLICK", e);
      let pegawaiId = e.element.id;
      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "simpeg-pegawai-detail",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }
      // if (e.itemData === "Delete") {
      //   let result = confirm(
      //     "<i>Yakin menghapus data pegawai?</i>",
      //     "Konfirmasi"
      //   );
      //   result.then((dialogResult) => {
      //     console.log(dialogResult);
      //     if (dialogResult) {
      //       //delete
      //       axios
      //         .delete(`${ODATA_BASE_URL}/SimpegPegawais/` + pegawaiId, {
      //           headers: {
      //             Authorization: api.defaults.headers.common["Authorization"],
      //             "Content-Type": "application/json",
      //           },
      //         })
      //         .then((response) => {
      //           console.log(response);
      //           notify("Data Pegawai berhasil dihapus", "success");
      //           this.$refs.gridRef.instance.refresh();
      //         })
      //         .catch((error) => {
      //           notify("Axios post error.", "error");
      //           console.log(error);
      //         });
      //     }
      //   });
      // }

      // notify(e.itemData.name || e.itemData, "success", 600);
      // this.router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: pegawaiId },
      // }); //id terlihat di url ||GAGAL
      // this.$router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: pegawaiId },
      // }); ||BERHASIL

      // this.router.push({
      //   name: "simpeg-pegawai-detail",
      //   params: { id: pegawaiId },
      // }); //id tak terlihat di url PARAMS GA KEPASS ||GAGAL

      // let data = {
      //   id: 25,
      //   description: "pass data through params",
      // };

      // this.router.push({ name: "simpeg-pegawai-detail", params: { data } }); ||GAGAL
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Pegawai.xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "pegawaiGajiDetails/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "simpegNaikPangkats/") ||
    _.includes(str, "simpegKgbs/")
  );
}

function convertFilter(filter, regVar) {
  if (regVar === "simpegKgbs") console.log("debug", "masuk convertFilter");
  //FIXME: HANYA UNTUK RIWAYAT GOLONGAN N RIWAYAT PEKERJAAN YG ADA STATUS EQ 1

  //lama, cuma bisa handling eq
  // const regex = new RegExp(`${regVar}\\[\\d+\\]\/(\\w+) eq (\\d+)`, "g");
  // if (regVar === "simpegKgbs") console.log("debug", "regex", regex);
  // const outputString = filter.replace(regex, (match, p1, p2) => {
  //   return `${regVar}/any(s:s/${p1} eq ${p2} and s/status eq 1)`;
  // });

  const operators = ["eq", "ne", "gt", "ge", "lt", "le"];
  const regex = new RegExp(
    `${regVar}\\[\\d+\\]\/(\\w+) (${operators.join("|")}) (\\d+)`,
    "g"
  );

  const outputString = filter.replace(regex, (match, p1, operator, p2) => {
    return `${regVar}/any(s:s/${p1} ${operator} ${p2} and s/status eq 1)`;
  });

  if (outputString) console.log("debug", "horee!! ada outputstring");
  if (regVar === "simpegKgbs")
    console.log("debug", "hasiloutputstring", outputString);
  return outputString;
}

function convertDatagridFilterNested(filter, regVar) {
  console.log("asli", filter);
  console.log("riwayatGolongans/any(s:s/golongan_id eq 2)");
  // return "riwayatGolongans/any(s:s/golongan_id eq 2)";
  console.log("filter", filter);
  console.log("regVar", regVar);
  var regex = new RegExp(`\\${regVar}\\/[^)]+\\)`, "g");

  filter = "(" + filter + ")";

  console.log("regex", regex);
  var occurrences = filter.match(regex);
  console.log("occurrences", occurrences);
  if (occurrences != null) {
    //biar dapat ['(pegawaiGajiDetails[0]/jml eq 23)', '(pegawaiGajiDetails[1]/jml eq 23)']
    var modifiedArr = occurrences.map((str) => {
      var modifiedString = str
        .replace(/\[\d+\]/g, "")
        .replace(
          new RegExp(`(${regVar}\\/)(.+)`),
          (match, capture1, capture2) => `${capture1}any(s:s/${capture2}`
        );
      return modifiedString + ")";
    });

    occurrences.forEach((extracted, index) => {
      filter = filter.replace(extracted, modifiedArr[index]);
    });
  }
  console.log("hasilfilter", filter);
  return filter;
}

// const bagians = [
//   { name: "Litbang", value: "Litbang" },
//   { name: "Produksi", value: "Produksi" },
//   { name: "Distribusi", value: "Distribusi" },
//   { name: "Akuntansi", value: "Akuntansi" },
//   { name: "Keuangan", value: "Keuangan" },
//   { name: "Personalia", value: "Personalia" },
// ];

// const subBagians = [{ name: "TI", value: "TI" }];

// const jabatans = [
//   { name: "Kabag", value: "Kabag" },
//   { name: "Kasubag", value: "Kasubag" },
//   { name: "Staf", value: "Staf" },
//   { name: "Direktur Utama", value: "Direktur Utama" },
// ];

// const golongans = [
//   { name: "A1", value: "A1" },
//   { name: "B1", value: "B1" },
//   { name: "C1", value: "C1" },
// ];

// const statuss = [
//   { name: "Pegawai Tetap", value: "Pegawai Tetap" },
//   { name: "Calon Pegawai", value: "Calon Pegawai" },
//   { name: "Kontrak", value: "Kontrak" },
//   { name: "Training", value: "Training" },
// ];

// const agamas = [
//   { name: "Hindu", value: "Hindu" },
//   { name: "Islam", value: "Islam" },
//   { name: "Buddha", value: "Buddha" },
// ];
</script>

<style>
/* .dx-datagrid-headers {
  background-color: red !important;
}
.dx-datagrid-headers {
  background-color: red !important;
} */
</style>
